import { Component, effect, inject, resource, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TAGEvent } from '../../../models/tagevent';
import { Subscription } from 'rxjs';
import { TAGImage } from '../../../models/tagimage';
import { TAGImageCategory } from '../../../models/tagimagecategory';
import { ApiService } from '../../api.service';
import { TranslatePipe } from '@ngx-translate/core';
import { EventListitemComponent } from '../../components/event-listitem/event-listitem.component';
import { DatePipe } from '@angular/common';
import { TimeSpanPipe } from '../../timespan.pipe';
import { APIError } from '../../../models/apierror';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-events',
  imports: [TranslatePipe, EventListitemComponent, DatePipe, TimeSpanPipe, SkeletonModule],
  templateUrl: './events.html',
  styleUrl: './events.scss',
})
export class Events {
  private api = inject(ApiService);
  private route = inject(ActivatedRoute);

  preSelectID = signal<string>(undefined);

  /*   loading = signal(true);
  events = signal<TAGEvent[]>([]); */

  selectedEvent = signal<TAGEvent>(undefined);
  /* eventCategory = signal<TAGImageCategory>(undefined);
  eventImages = signal<TAGImage[]>([]); */

  paramsSub: Subscription = null;

  events = resource({
    defaultValue: [] as TAGEvent[],
    loader: ({}) => {
      return new Promise<TAGEvent[]>((resolve, reject) => {
        this.api.waitForAPI().then(() => {
          this.api
            .getEvents(true)
            .then((events: TAGEvent[]) => {
              //return resolve([]);
              console.log(events);
              events.sort((a, b) => a.startdate.getTime() - b.startdate.getTime());
              resolve(events.filter((e) => e.enddate > new Date()));
            })
            .catch((reason) => {
              reject(reason);
            });
        });
      });
    },
  });

/*   eventCategory = resource({
    params: () => ({ eventId: this.selectedEvent()?._id ?? undefined }),
    loader: ({ params }) => {
      return new Promise<TAGImageCategory>((resolve, reject) => {
        if (!params.eventId) return resolve(undefined);

        this.api.waitForAPI().then(() => {
          this.api
            .getImageCategoryForEvent(params.eventId)
            .then((result: TAGImageCategory) => {
              resolve(result);
            })
            .catch((reason: APIError) => {
              console.log(reason);
              if (reason.status == 404) resolve(undefined);
              else reject(reason);
            });
        });
      });
    },
  });

  eventImages = resource({
    params: () => ({ imageCategoryId: this.eventCategory.value()?._id ?? undefined }),
    loader: ({ params }) => {
      return new Promise<TAGImage[]>((resolve, reject) => {
        if (!params.imageCategoryId) return resolve([]);

        this.api.waitForAPI().then(() => {
          this.api
            .getImages(params.imageCategoryId)
            .then((result: TAGImage[]) => {
              resolve(result);
            })
            .catch((reason) => {
              reject(reason);
            });
        });
      });
    },
  }); */

  eventTimespan(start: Date, end: Date) {
    let startTime = start.getTime();
    let endTime = end.getTime();
    return (endTime - startTime) / 1000;
  }

  constructor() {
    effect(() => {
      if (this.events.value()) {
        console.log('Selecting Initial Event');
        if (this.preSelectID() && this.events.value().find((e) => e._id === this.preSelectID())) {
          this.selectEvent(this.events.value().find((e) => e._id === this.preSelectID()));
        } else {
          this.selectEvent(this.events.value()[0]);
        }
      }
    });
  }

  ngOnInit() {
    this.paramsSub = this.route.queryParamMap.subscribe((params) => {
      console.log(params);
      if (params.get('eventid')) {
        this.preSelectID.set(params.get('eventid'));
      }
    });
  }

  ngOnDestroy() {
    if (this.paramsSub) this.paramsSub.unsubscribe();
  }

  selectEvent(event: TAGEvent) {
    this.selectedEvent.set(event);
  }
}
